@let editingPageConfiguration = store.editingPageConfigurationSg();

<div class="atn-page-configuration-general-tab">
  <atn-ds-text
    label="Name"
    placeholder="Enter a name"
    [value]="editingPageConfiguration?.name"
    (change)="updatePageConfiguration('name', $event)"
  ></atn-ds-text>
  <atn-ds-text
    label="Alias"
    placeholder="Enter an alias"
    [value]="editingPageConfiguration?.alias"
    (change)="updatePageConfiguration('alias', $event)"
  ></atn-ds-text>
  <atn-ds-text
    label="Description"
    placeholder="Enter a description"
    [value]="editingPageConfiguration?.description"
    (change)="updatePageConfiguration('description', $event)"
  ></atn-ds-text>
</div>
